<template>
    <div class="login-bg">
        <div class="login-container">
            <div class="left">
                <img src="../../assets/login_left.png" alt="">
            </div>
            <div class="right">
                <div class="site_name"> {{ cfg.app_name }}</div>
                <el-form label-width="0">
                    <el-form-item>
                        <el-select v-model="r.admin_group_id" placeholder="请选择身份" clearable filterable>
                            <el-option v-for="(item, index) in groups" :key="index" :label="item.title1"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="r.admin_name" placeholder="单位名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="r.phone" placeholder="手机号"></el-input>
                        <div class="f-129">绑定手机后可使用手机登录</div>
                    </el-form-item>
                    <el-form-item>
                        <div class="flex">
                            <el-input class="flex-1 mr-10" v-model="r.pcode" placeholder="短信验证码"></el-input>
                            <ls-pcode :phone="r.phone" scene="reg"></ls-pcode>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-input type="password" v-model="r.password" placeholder="密码"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input type="password" v-model="r.password_confirm" placeholder="确认密码"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="r.name" placeholder="联系人"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <div class="flex">
                            <el-input v-model="r.captcha" placeholder="图形验证码"></el-input>
                            <div @click="_recode">
                                <ls-captcha :code="code"></ls-captcha>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item class="mt-20">
                        <el-button type="primary" style="width: 100%;" @click="_submit">注册</el-button>
                    </el-form-item>
                </el-form>
                <div @click="_to_url(`/login`)" class="a c-primary mv-20 center">登录</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            r: {
                code: ''
            },
            code: "",
            codes: "0123456789abcdwerwshdje",
            cfg: {},
            groups: []
        };
    },
    created() {
        this._recode();
        this._groups();
        this._config(['app_name']);
    },
    methods: {
        _groups() {
            this.$http.post('admin_group/list', {
                is_reg: 1
            }).then(res => {
                if (res.code) {
                    this.groups = res.data.data;
                }
            })
        },
        _recode() { //
            this.code = "";
            this.r.code = '';
            this._code(this.codes, 4);
        },
        _rnum(min, max) {
            max = max + 1
            return Math.floor(Math.random() * (max - min) + min)
        },
        // 随机生成验证码字符串
        _code(data, len) {
            for (let i = 0; i < len; i++) {
                this.code += data[this._rnum(0, data.length - 1)]
            }
        },
        _submit() {
            if (this.r.captcha != this.code) {
                this.$message.error('验证码错误');
                return;
            }
            this.$http.post('admin/reg', {
                ...this.r
            }).then(res => {
                if (res.code) {
                    this._to_url('/login');
                }
            })
        }
    },
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>